import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

const TotalLabel = styled.div`
    text-align: right;
    font-weight: 700;
`

export const UiTotalLabel = () => {
	const { t } = useTranslation()

	return (
		<TotalLabel>
			{`${t(ALL_LANG_KEY.general.total_label)}:`}
		</TotalLabel>
	)
}